import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAppOcrOnOff, useAsideState } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';

function GlobalMyPageHeader(props) {
  const history = useHistory();
  const { t } = useTranslation(); 
  const { setAsideState } = useAsideState();
  const { handleOcr } = useAppOcrOnOff();
  const { setAmplitudeLog } = useAmplitude();

  const handleClick = useCallback(() => {
    setAsideState({ menu: true });
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '메인메뉴 조회'});
  }, [])

  return (
    <div className="header_top gb bg_sky">
      <div className="inner">
        <div className="btns_wrap">
          <div className="center_wrap cls">
            <div className="tit_area">
              <button
                className="btn_exit"
                type="button"
                onClick={() => history.goBack()}
              >
                  <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
              <button
                className="tit_btn"
                type="button"
                onClick={() => history.goBack()}
              >{t("MY_03_05.msg011")}</button>
            </div>
            <div className="right_area">
              <div className="menu_btn">
                <button
                  type="button"
                  onClick={handleOcr}
                >
                  <img src="./static/images/icon/btn_ocr_th.svg" alt="" />
                </button>
                <button
                  type="button"
                  onClick={handleClick}
                >
                  <img src="./static/images/icon/btn_menu_th.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GlobalMyPageHeader;